import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { FaAndroid, FaDownload } from 'react-icons/fa';
import './InstallPopup.scss';

const DISMISS_KEY = 'mivent_install_popup_dismissed';
const SESSION_KEY = 'mivent_install_popup_shown_session';

const InstallPopup = () => {
  const [dontAskAgain, setDontAskAgain] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const { isAuthenticated } = useSelector((state) => state.auth);

  useEffect(() => {
    if (!isAuthenticated) {
      setShowModal(false);
      return;
    }

    const permanentlyDismissed = localStorage.getItem(DISMISS_KEY) === 'true';
    const shownThisSession = sessionStorage.getItem(SESSION_KEY) === 'true';

    if (!permanentlyDismissed && !shownThisSession) {
      const timer = setTimeout(() => setShowModal(true), 1500);
      return () => clearTimeout(timer);
    }
  }, [isAuthenticated]);

  const handleDone = () => {
    if (dontAskAgain) {
      localStorage.setItem(DISMISS_KEY, 'true');
    }
    sessionStorage.setItem(SESSION_KEY, 'true');
    setShowModal(false);
  };

  const handleCancel = () => {
    sessionStorage.setItem(SESSION_KEY, 'true');
    setShowModal(false);
  };

  if (!showModal) return null;

  return (
    <div className="install-popup-overlay">
      <div className="install-popup-modal">
        <div className="install-popup-header">
          <h2>Install MIVENT App</h2>
          <p>Choose your platform and download the app for the best experience.</p>
        </div>

        <div className="install-popup-cards">
          <div className="install-popup-card">
            <div className="install-popup-card-icon">
              <FaAndroid />
            </div>
            <h4>Android</h4>
            <p>APK file for Android devices</p>
            <a href="/MIVENT.apk" className="install-popup-btn" download>
              <FaDownload /> Download APK
            </a>
          </div>

        </div>

        <label className="install-popup-checkbox">
          <input
            type="checkbox"
            checked={dontAskAgain}
            onChange={(e) => setDontAskAgain(e.target.checked)}
          />
          Don't ask again
        </label>

        <div className="install-popup-footer">
          <button className="install-popup-btn install-popup-btn--cancel" onClick={handleCancel}>
            Cancel
          </button>
          <button className="install-popup-btn install-popup-btn--done" onClick={handleDone}>
            Done
          </button>
        </div>
      </div>
    </div>
  );
};

export default InstallPopup;
